import React, { useEffect, useState, useCallback, useMemo } from "react";
import {
  Button,
  Form,
  Input,
  Modal,
  message,
  Spin,
  Radio,
  Divider,
  Row,
  Col,
  InputNumber,
  Select,
  Tag,
  Space,
  Typography,
  List,
} from "antd";
import {
  CheckCircleOutlined,
  CloseCircleOutlined,
  FileTextOutlined,
  DownSquareOutlined,
  UpSquareOutlined,
  EyeOutlined,
} from "@ant-design/icons";
import axios from "axios";
import dayjs from "dayjs";
import {
  HEADERS_EXPORT_BEN,
  POST_APPEAL_LAWYER,
  POST_CREATE_LAWSUIT,
  POST_DETAIL_PAYMENT,
  POST_LAWSUIT_DETAIL,
  POST_LITIGATION_FUNDS,
  POST_LOAD_DETAIL_OLD_DATA,
} from "../../../API/apiUrls";
import DateCustom from "../../../../hook/DateCustom";
import CurrencyFormat from "../../../../hook/CurrencyFormat";
import { optionsLone } from "../constant/LoanTypeConstant";
import ThaiDatePicker from "../../../../hook/ThaiDatePicker";
import { optionsCompany } from "../constant/selectCompany";
import { allCourtOptions } from "../constant/court";
import DebtPayment from "../../preInvestigateAssets/modal/DebtPayment";
import DetailAsset from "./DetailAssets";
import DetailNotify from "./DetailNotify";
import DetailWcc from "./DetailWcc";
import AddressTrDetail from "./AddressTrDetail";

const { TextArea } = Input;

// ========================================
// Utility Functions
// ========================================

const calculateCourtFee = (value) => {
  console.log("calculateCourtFee", value);

  if (!value) return 0;
  let fee;
  if (value <= 300000) {
    fee = value * 0.02;
    fee = fee > 1000 ? 1000 : fee;
  } else {
    fee = value * 0.02;
  }
  return Math.ceil(fee + 100);
};

const calculateLostBenefit = (dataLeasingCase, selectedValue) => {
  if (!dataLeasingCase) return 0;
  const { usableCapital, lost_profit_amount, balanc, netpay } = dataLeasingCase;
  return lost_profit_amount || 0;
  // if (usableCapital === selectedValue) {
  //   return lost_profit_amount || 0;
  // }

  // let lostBenefit;
  // if (usableCapital !== 300000) {
  //   lostBenefit = 300000 - (balanc - netpay);
  // } else {
  //   lostBenefit = balanc - netpay;
  // }
  // return lostBenefit < 0 ? 0 : lostBenefit;
};

// ========================================
// Main Component
// ========================================

const SendToLawsuit = ({ open, close, dataDefault, funcUpdateStatus }) => {
  const [form] = Form.useForm();
  const userId = parseInt(localStorage.getItem("USER_ID"));
  const userCompany = localStorage.getItem("COMPANY_ID");

  const [convertDateThai] = DateCustom();
  const [
    currencyFormat,
    currencyFormatComma,
    currencyFormatPoint,
    currencyFormatNoPoint,
  ] = CurrencyFormat();

  // States
  const [loading, setLoading] = useState(false);
  const [radioStatus, setRadioStatus] = useState(null);
  const [dataLeasingCase, setDataLeasingCase] = useState(null);
  const [dataLoadLawsuit, setDataLoadLawSuit] = useState(null);
  const [dataAsset, setDataAsset] = useState([]);
  const [workLawsuitDoc, setWorkLawsuitDoc] = useState(null); // ⭐ เพิ่ม state
  const [isEditMode, setIsEditMode] = useState(false);
  const [isModalDebtPayment, setIsModalDebtPayment] = useState(false);
  const [dataNote, setDataNote] = useState([]);
  const [isModalWcc, setIsModalWcc] = useState(false);
  const [isModalNotify, setIsModalNotify] = useState(false);
  const [isModalDetailAsset, setIsModalDetailAsset] = useState(false);
  const [showNote, setShowNote] = useState(false);
  const [isModalDetailTr, setIsModalDetailTr] = useState(false);
  const [litigationFoundsUseCal, setLitigationFoundsUseCal] = useState(0);
  const [lostProfitAmountUseCal, setLostProfitAmountUseCal] = useState(0);
  const [lawsuitOldData, setLawsuitOldData] = useState({});
  const [oldJudgeDetail, setOldJudgeDetail] = useState(null);

  const litigationOptions = useMemo(() => {
    console.log(dataLeasingCase);

    if (!dataLeasingCase) {
      return [{ label: "ไม่พบข้อมูล", value: 0, disabled: true }];
    }
    if (dataDefault.SCHEMA === "lsfhp" || dataDefault.SCHEMA === "rpsl") {
      const { tonkong, dok } = dataLeasingCase.loan;
      const totalAmount = tonkong;

      const options = [
        {
          label: `${currencyFormatComma(totalAmount.toFixed(2))} บาท`,
          value: parseFloat(totalAmount.toFixed(2)),
        },
      ];

      options.push({
        label: `กำหนดเอง`,
        value: 0,
      });

      return options;
    } else {
      const { usableCapital, litigation_capital } = dataLeasingCase;
      const options = [
        {
          label: `${currencyFormatComma(usableCapital)} บาท`,
          value: usableCapital,
        },
      ];

      // เพิ่ม option ที่ 2 ตามเงื่อนไข
      if (litigation_capital !== usableCapital) {
        options.push({
          label: `${currencyFormatComma(litigation_capital)} บาท`,
          value: litigation_capital,
        });
      } else {
        options.push({
          label: `กำหนดเอง`,
          value: 0,
        });
      }

      // เพิ่ม option ที่ 2 ตามเงื่อนไข
      // if (litigation_capital !== usableCapital && usableCapital >= 300000) {
      //   options.push({
      //     label: `${currencyFormatComma(litigation_capital)} บาท`,
      //     value: litigation_capital,
      //   });
      // } else if (usableCapital < 300000) {
      // options.push({
      //   label: `300,000 บาท`,
      //   value: 300000,
      // });
      // } else {
      //   options.push({
      //     label: `300,000 บาท`,
      //     value: 300000,
      //   });
      // }

      return options;
    }
  }, [dataLeasingCase, currencyFormatComma]);

  // ========================================
  // Set Default Values (Edit Mode)
  // ========================================
  // ✅ แยก function ออกมาข้างนอก
  const calculateDocCostExpense = (lawsuitData) => {
    // ถ้ามี workExpenseList ให้หาค่าจัดทำเอกสาร (expenseTypeId = 4)
    if (lawsuitData?.workExpenseList?.length > 0) {
      const docExpense = lawsuitData.workExpenseList.find(
        (item) => item.expenseTypeId === 4,
      );
      console.log("docExpense", docExpense);

      if (docExpense?.NETPAY) {
        return parseFloat(docExpense.NETPAY);
      }
    }

    // ถ้าไม่มี คำนวณจากจำนวนคน (ผู้เช่าซื้อ 1 + ผู้ค้ำ n) * 100
    const guarantorCount = lawsuitData?.loanOld?.guarantors?.length || 0;
    return (guarantorCount + 1) * 100 + 600;
  };

  const calculateCourtFeeExpense = (lawsuitData) => {
    if (lawsuitData?.workExpenseList?.length > 0) {
      const docExpense = lawsuitData.workExpenseList.find(
        (item) => item.expenseTypeId === 1,
      );
      console.log("docExpense", docExpense);

      if (docExpense?.NETPAY) {
        return parseFloat(docExpense.NETPAY);
      }
    }

    let fee;
    if (lawsuitData.litigationFunds <= 300000) {
      fee = lawsuitData.litigationFunds * 0.02;
      fee = fee > 1000 ? 1000 : fee;
    } else {
      fee = lawsuitData.litigationFunds * 0.02;
    }
    return Math.ceil(fee + 100);
  };

  const calculateDeliveryExpense = (lawsuitData) => {
    if (lawsuitData?.workExpenseList?.length > 0) {
      const docExpense = lawsuitData.workExpenseList.find(
        (item) => item.expenseTypeId === 2,
      );
      console.log("docExpense", docExpense);
      if (docExpense?.NETPAY) {
        return parseFloat(docExpense.NETPAY);
      }
    }

    return 0;
  };

  const dataDefaultValues = useCallback(
    (lawsuitData) => {
      if (!lawsuitData) return;

      console.log("🔧 Setting default values:", lawsuitData);

      // ⭐ ตรวจสอบว่าเป็นโหมดแก้ไขหรือไม่
      const hasExistingData =
        dataDefault.currentStatus === 4 && dataDefault.currentProcess;
      console.log("hasExistingData", hasExistingData);

      setIsEditMode(!!hasExistingData);
      if (lawsuitData.workExpenseList) {
      }
      // ⭐ คำนวณค่าต่างๆ
      const litigationValue =
        lawsuitData.litigationFunds || lawsuitData.preLitigationFunds || 0;
      const courtFeeValue =
        lawsuitData.fee ||
        calculateCourtFee(parseFloat(lawsuitData.preLitigationFunds));
      setLitigationFoundsUseCal(
        parseFloat(lawsuitData.preLitigationFunds) || 0,
      );
      setLostProfitAmountUseCal(parseFloat(lawsuitData.preLackOfBenefits) || 0);

      const defaultValues = {
        loanType: lawsuitData.LAW_TYPE_ID || undefined,
        subject: lawsuitData.subject || undefined,
        preLitigationFounds: parseFloat(lawsuitData.preLitigationFunds) || 0,
        preLostProfitAmount: parseFloat(lawsuitData.preLackOfBenefits) || 0,
        litigationFounds:
          parseFloat(lawsuitData.litigationFunds) ||
          parseFloat(lawsuitData.preLitigationFunds) ||
          0,
        lostProfitAmount:
          parseFloat(lawsuitData.lackOfBenefits) ||
          parseFloat(lawsuitData.preLackOfBenefits) ||
          0,
        courtFee:
          dataDefault.currentStatus === 7
            ? parseFloat(courtFeeValue)
            : calculateCourtFeeExpense(lawsuitData),
        lawyerChoose: lawsuitData.userId || undefined,
        memo: lawsuitData.mark || undefined,
        docCost: calculateDocCostExpense(lawsuitData), // ✅ เรียกใช้ function
        deliveryDoc: calculateDeliveryExpense(lawsuitData),
        lawType: lawsuitData.LAW_TYPE_ID,
        dateCourt: lawsuitData.dateOfPlaint
          ? dayjs(lawsuitData.dateOfPlaint)
          : null, // ✅ แก้ logic
        company: lawsuitData.COMPANY_ID,
        court: lawsuitData.provincialCourt,
        trackingFee: lawsuitData.trackingFee,
      };
      // ⭐ Set radio status
      if (litigationValue) {
        setRadioStatus(parseFloat(litigationValue));
      }

      form.setFieldsValue(defaultValues);
      console.log("✅ Default values set:", defaultValues);
      console.log("📋 Edit mode:", hasExistingData);
    },
    [form],
  );

  // ========================================
  // Load Main Data
  // ========================================

  const loadData = useCallback(async () => {
    setLoading(true);
    const controller = new AbortController();

    try {
      const [lawsuitRes] = await Promise.all([
        axios.post(
          POST_LAWSUIT_DETAIL,
          {
            CONTNO: dataDefault.CONTNO,
            loanId: dataDefault.loanId,
            lawsuitId: dataDefault.lawsuitId,
          },
          {
            headers: HEADERS_EXPORT_BEN,
            signal: controller.signal,
          },
        ),
      ]);

      // Handle lawsuit response
      if (lawsuitRes?.data) {
        console.log("✅ lawsuitRes:", lawsuitRes.data);
        setDataLoadLawSuit(lawsuitRes.data.lawsuit);
        setDataAsset(lawsuitRes.data.asset || []);
        setDataNote(lawsuitRes.data.note || []);
        // ⭐ เพิ่ม: ดึงข้อมูล workLawsuitDoc
        setWorkLawsuitDoc(lawsuitRes.data.lawsuit?.workLawsuitDoc || null);
        setLawsuitOldData(lawsuitRes.data.oldJudge);
        console.log(
          "✅ workLawsuitDoc:",
          lawsuitRes.data.lawsuit?.workLawsuitDoc,
        );

        dataDefaultValues(lawsuitRes.data.lawsuit);

        // ถ้ามีคำพิพากษาเดิม ให้โหลดรายละเอียดเพิ่ม
        const oldJudge = lawsuitRes.data.oldJudge;
        if (oldJudge) {
          try {
            const oldRes = await axios.post(
              POST_LOAD_DETAIL_OLD_DATA,
              {
                CONTNO: oldJudge.newContno,
                lawsuitId: oldJudge.lawsuitId,
                loanId: oldJudge.loanId,
              },
              {
                headers: HEADERS_EXPORT_BEN,
                signal: controller.signal,
              },
            );
            setOldJudgeDetail(oldRes?.data || null);
          } catch (err) {
            if (err.name !== "CanceledError") {
              console.error("❌ Error loading old judge:", err);
              setOldJudgeDetail(null);
            }
          }
        } else {
          setOldJudgeDetail(null);
        }
      } else {
        throw new Error("ไม่พบข้อมูลคดี");
      }

      // Handle leasing response
    } catch (error) {
      if (error.name !== "CanceledError") {
        console.error("❌ Error loading data:", error);
        const errorMsg = error.response?.data?.message || error.message;
        message.error(`เกิดข้อผิดพลาด: ${errorMsg}`);
      }
    } finally {
      setLoading(false);
    }

    return () => controller.abort();
  }, [dataDefault, dataDefaultValues]);

  useEffect(() => {
    if (open) {
      loadData();
    }
  }, [open, loadData]);

  const loadLeasing = useCallback(async (dataLoad, api) => {
    setLoading(true);
    const controller = new AbortController();

    try {
      const [leasingRes] = await Promise.all([
        axios.post(api, dataLoad, {
          headers: HEADERS_EXPORT_BEN,
          signal: controller.signal,
        }),
      ]);
      console.log("leasingRes", leasingRes);

      // Handle leasing response
      if (
        leasingRes?.data?.[0] &&
        leasingRes?.data !== "ยังไม่ได้ทำตัวสัญญาที่ดิน"
      ) {
        console.log("✅ leasingRes:", leasingRes.data[0]);
        setDataLeasingCase(leasingRes.data[0]);
      } else {
        message.warning("ไม่พบข้อมูลสัญญาในระบบ");
      }
    } catch (error) {
      if (error.name !== "CanceledError") {
        console.error("❌ Error loading data:", error);
        const errorMsg = error.response?.data?.message || error.message;
        message.error(`เกิดข้อผิดพลาด: ${errorMsg}`);
      }
    } finally {
      setLoading(false);
    }

    return () => controller.abort();
  }, []);

  // ========================================
  // Form Handlers
  // ========================================

  const handleLoadDataLeasing = (date) => {
    console.log("dataDefault", dataDefault);
    let dataLoad;
    let api;
    if (date) {
      if (dataDefault.SCHEMA === "lsfhp" || dataDefault.SCHEMA === "rpsl") {
        api = POST_DETAIL_PAYMENT;
        dataLoad = {
          contno: dataDefault.CONTNO,
          todate: dayjs(date).format("YYYY-MM-DD"),
          type: dataDefault.SCHEMA?.toUpperCase(),
        };
      } else {
        dataLoad = {
          contno: dataDefault.CONTNO,
          type: dataDefault.SCHEMA?.toUpperCase(),
          todate: dayjs(date).format("YYYY-MM-DD"),
          // asset: dataAsset.length > 0 ? "1" : "0",
          asset: "1",
        };
        api = POST_LITIGATION_FUNDS;
      }
      loadLeasing(dataLoad, api);
    }
  };

  const onChangeSelectLoanType = useCallback(
    (value) => {
      console.log(`Selected law type: ${value}`);

      const subjectMap = {
        2: "บอกกล่าวบังคับจำนอง",
        5: "บอกกล่าวบังคับจำนอง",
        6: "ผิดสัญญาเช่าซื้อ, สัญญาค้ำประกัน, เรียกค่าเสียหาย (ฟ้องส่วนต่าง)",
        7: "ยักยอกทรัพย์",
        8: "ฉ้อโกง",
      };

      const subject =
        subjectMap[value] ||
        "ผิดสัญญาเช่าซื้อ, สัญญาค้ำประกัน, เรียกค่าเสียหาย";

      form.setFieldsValue({ subject });
    },
    [form],
  );

  const onChangeInvestiGateResult = useCallback(
    ({ target: { value } }) => {
      setRadioStatus(value);
      console.log("onChangeInvestiGateResult", value);
      console.log(lostProfitAmountUseCal);

      const courtFee = calculateCourtFee(
        value + (value ? lostProfitAmountUseCal : 0),
      );
      const lostBenefit = calculateLostBenefit(dataLeasingCase, value);

      form.setFieldsValue({
        litigationFounds: value,
        courtFee,
        lostProfitAmount: value ? lostBenefit : lostProfitAmountUseCal,
      });
      setLitigationFoundsUseCal(value);
      setLostProfitAmountUseCal(value ? lostBenefit : lostProfitAmountUseCal);

      console.log("Selected litigation funds:", value);
      console.log("Calculated court fee:", courtFee);
      console.log("Calculated lost benefit:", lostBenefit);
    },
    [dataLeasingCase, form],
  );

  // Simplified onChange handlers
  const onChangelitigationFounds = useCallback((value) => {
    setLitigationFoundsUseCal(value);
  }, []);

  const onChangelostProfitAmount = useCallback((value) => {
    setLostProfitAmountUseCal(value);
  }, []);

  useEffect(() => {
    const courtFee = calculateCourtFee(litigationFoundsUseCal);

    console.log("courtFee", courtFee);
    form.setFieldsValue({ courtFee });
  }, [litigationFoundsUseCal, form]);

  const handleCancel = useCallback(() => {
    console.log("Modal closed");
    form.resetFields();
    setRadioStatus(null);
    setIsEditMode(false);
    close(false);
  }, [close, form]);

  const sendData = useCallback(
    async (dataLawsuit, useApi) => {
      console.log("📤 Sending lawsuit data:", dataLawsuit);
      setLoading(true);
      try {
        const response = await axios.post(useApi, dataLawsuit, {
          headers: HEADERS_EXPORT_BEN,
        });

        if (response.status === 200 || response.status === 201) {
          console.log("✅ Data sent successfully:", response.data);
          message.success(
            isEditMode ? "แก้ไขข้อมูลสำเร็จ" : "บันทึกข้อมูลสำเร็จ",
          );
          funcUpdateStatus?.();
          handleCancel();
        } else {
          throw new Error("ไม่สามารถบันทึกข้อมูลได้");
        }
      } catch (error) {
        console.error("❌ Error sending data:", error);
        const errorMsg = error.response?.data?.message || error.message;
        message.error(`เกิดข้อผิดพลาด: ${errorMsg}`);
      } finally {
        setLoading(false);
      }
    },
    [funcUpdateStatus, handleCancel, isEditMode],
  );

  const onFinish = useCallback(
    (values) => {
      console.log("📝 Form submitted:", values);
      console.log("📋 dataLoadLawsuit:", dataLoadLawsuit);

      const dataLawsuit = {
        ...dataLoadLawsuit,
        lackOfBenefits: values.lostProfitAmount,
        fee: values.courtFee,
        litigationFunds: values.litigationFounds,
        mark: values.memo || null,
        subject: values.subject,
        LAW_TYPE_ID: values.lawType,
        COMPANY_ID: values.company,
        dateOfPlaint: values.dateCourt,
        provincialCourt: values.court,
        trackingFee: values.trackingFee || null,
        lawsuitId:
          dataDefault.currentStatus === 13 ? 0 : dataLoadLawsuit.lawsuitId,
        workExpenseList: [
          (() => {
            // ✅ แก้ไข: ถ้ามี TMBILL อยู่แล้ว ใช้ข้อมูลเดิมทั้งหมด, ถ้าไม่มีใช้ค่าจากฟอร์ม
            const existingExpense = dataLoadLawsuit?.workExpenseList?.find(
              (item) => item.expenseTypeId === 1,
            );
            if (existingExpense?.TMBILL) {
              return existingExpense;
            }
            return {
              id:
                dataDefault.currentStatus === 7 ? 0 : existingExpense?.id || 0,
              TMBILL: null,
              lawsuitId: dataLoadLawsuit.lawsuitId,
              expenseTypeId: 1,
              NETPAY: values.courtFee,
              NETPAY_DT: null,
              payTypeId: null,
              PAY: null,
              PAYDT: null,
              FLAG: null,
              CANDT: null,
              CANDT_USER: null,
              description: null,
            };
          })(),
          (() => {
            // ✅ แก้ไข: ถ้ามี TMBILL อยู่แล้ว ใช้ข้อมูลเดิมทั้งหมด, ถ้าไม่มีใช้ค่าจากฟอร์ม
            const existingExpense = dataLoadLawsuit?.workExpenseList?.find(
              (item) => item.expenseTypeId === 2,
            );
            if (existingExpense?.TMBILL) {
              return existingExpense;
            }
            return {
              id:
                dataDefault.currentStatus === 7 ? 0 : existingExpense?.id || 0,
              TMBILL: null,
              lawsuitId: dataLoadLawsuit.lawsuitId,
              expenseTypeId: 2,
              NETPAY: values.deliveryDoc,
              NETPAY_DT: null,
              payTypeId: null,
              PAY: null,
              PAYDT: null,
              FLAG: null,
              CANDT: null,
              CANDT_USER: null,
              description: null,
            };
          })(),
          (() => {
            // ✅ แก้ไข: ถ้ามี TMBILL อยู่แล้ว ใช้ข้อมูลเดิมทั้งหมด, ถ้าไม่มีใช้ค่าจากฟอร์ม
            const existingExpense = dataLoadLawsuit?.workExpenseList?.find(
              (item) => item.expenseTypeId === 4,
            );
            if (existingExpense?.TMBILL) {
              return existingExpense;
            }
            return {
              id:
                dataDefault.currentStatus === 7 ? 0 : existingExpense?.id || 0,
              TMBILL: null,
              lawsuitId: dataLoadLawsuit.lawsuitId,
              expenseTypeId: 4,
              NETPAY: values.docCost,
              NETPAY_DT: null,
              payTypeId: null,
              PAY: null,
              PAYDT: null,
              FLAG: null,
              CANDT: null,
              CANDT_USER: null,
              description: "",
            };
          })(),
        ],
      };
      console.log("dataLawsuit", dataLawsuit);
      const useApi =
        dataDefault.currentStatus === 13
          ? POST_APPEAL_LAWYER
          : POST_CREATE_LAWSUIT;
      sendData(dataLawsuit, useApi);
    },
    [dataLoadLawsuit, sendData],
  );

  const onFinishFailed = useCallback((errorInfo) => {
    console.log("❌ Form validation failed:", errorInfo);
    message.error("กรุณากรอกข้อมูลที่มีเครื่องหมาย * ให้ครบถ้วน");
  }, []);

  // ========================================
  // Render Components
  // ========================================

  const InfoItem = useCallback(
    ({ label, value, span = 8 }) => (
      <Col xs={24} sm={12} md={span}>
        <div
          style={{
            display: "flex",
            padding: "8px 0",
            borderBottom: "1px solid #f0f0f0",
            alignItems: "center",
          }}
        >
          <span
            style={{
              fontWeight: "600",
              minWidth: "140px",
              color: "#666",
            }}
          >
            {label}:
          </span>
          <span
            style={{
              flex: 1,
              color: "#000",
              paddingLeft: "12px",
            }}
          >
            {value}
          </span>
        </div>
      </Col>
    ),
    [],
  );

  // ⭐ Render เอกสารที่ใช้ฟ้อง (workLawsuitDoc)
  const renderDocumentChecklist = useMemo(() => {
    if (!workLawsuitDoc) return null;
    console.log("workLawsuitDoc", workLawsuitDoc);

    const documents = [
      {
        key: "docContno",
        label: "สำเนาสัญญา",
        value: workLawsuitDoc.docContnoLawyer,
        clickable: false, // ✅ เพิ่ม
      },
      {
        key: "docMainAsset",
        label: "เอกสารหลักทรัพย์",
        value: workLawsuitDoc.docMainAssetLawyer,
        clickable: false,
      },
      {
        key: "docCopyCard",
        label: "สำเนาบัตร",
        value: workLawsuitDoc.docCopyCardLawyer,
        clickable: false,
      },
      {
        key: "docDebtorCard",
        label: "การ์ดลูกหนี้",
        value: workLawsuitDoc.docDebtorCardLawyer,
        clickable: true, // ✅ กดได้
        onClick: () => setIsModalDebtPayment(true),
      },
      {
        key: "docNotify",
        label: "หนังสือบอกกล่าว",
        value: workLawsuitDoc.docNotify,
        clickable: true,
        onClick: () => setIsModalNotify(true),
      },
      {
        key: "docWcc",
        label: "หนังสือบอกเลิก",
        value: workLawsuitDoc.docWcc,
        clickable: true,
        onClick: () => setIsModalWcc(true),
      },
      {
        key: "addressTr",
        label: "ทร.14 (ไม่เกิน 1 เดือน)",
        value: workLawsuitDoc.docAddressTr,
        clickable: true,
        onClick: () => setIsModalDetailTr(true),
      },
      {
        key: "assetLand",
        label: "ทรัพย์",
        value: dataAsset.some((item) => item.assetLand.length > 0),
        clickable: true,
        onClick: () => {
          setIsModalDetailAsset(true);
        },
      },
    ];

    return (
      <>
        <Divider>
          <FileTextOutlined /> เอกสารที่ใช้ฟ้อง
        </Divider>
        <div
          style={{
            background: "#fafafa",
            padding: "16px",
            borderRadius: "8px",
            marginBottom: "16px",
          }}
        >
          <Row gutter={[16, 16]}>
            {documents.map(({ key, label, value, clickable, onClick }) => (
              <Col xs={24} sm={12} md={8} key={key}>
                <div
                  style={{
                    cursor: clickable && value ? "pointer" : "default",
                    padding: "8px",
                    borderRadius: "4px",
                    transition: "all 0.3s",
                    backgroundColor: "transparent",
                  }}
                  onClick={() => {
                    if (clickable && value && onClick) {
                      onClick();
                    }
                  }}
                  onMouseEnter={(e) => {
                    if (clickable && value) {
                      e.currentTarget.style.backgroundColor = "#e6f7ff";
                    }
                  }}
                  onMouseLeave={(e) => {
                    if (clickable && value) {
                      e.currentTarget.style.backgroundColor = "transparent";
                    }
                  }}
                >
                  <Space>
                    {value ? (
                      <CheckCircleOutlined
                        style={{ color: "#52c41a", fontSize: "18px" }}
                      />
                    ) : (
                      <CloseCircleOutlined
                        style={{ color: "#ff4d4f", fontSize: "18px" }}
                      />
                    )}
                    <span style={{ fontWeight: value ? "600" : "normal" }}>
                      {label}
                    </span>
                    <Tag color={value ? "success" : "default"}>
                      {value ? "มี" : "ไม่มี"}
                    </Tag>
                    {/* ✅ แสดง icon ดูรายละเอียดถ้ากดได้ */}
                    {clickable && value && (
                      <EyeOutlined
                        style={{
                          color: "#1890ff",
                          fontSize: "16px",
                        }}
                      />
                    )}
                  </Space>
                </div>
              </Col>
            ))}
          </Row>
          <div
            style={{ marginTop: "12px", fontSize: "12px", color: "#8c8c8c" }}
          >
            {dataNote?.length > 0 && (
              <>
                <Divider orientation="left">
                  <Space>
                    <Typography.Text
                      strong
                      onClick={() => {
                        setShowNote(!showNote);
                      }}
                      style={{ cursor: "pointer" }}
                    >
                      หมายเหตุก่อนหน้า
                    </Typography.Text>
                    <Tag
                      color="blue"
                      onClick={() => {
                        setShowNote(!showNote);
                      }}
                      style={{ cursor: "pointer" }}
                    >
                      {dataNote.length} รายการ{" "}
                      {!showNote ? (
                        <DownSquareOutlined />
                      ) : (
                        <UpSquareOutlined />
                      )}
                    </Tag>
                  </Space>
                </Divider>
                {showNote && (
                  <List
                    style={{ marginBottom: 16 }}
                    bordered
                    dataSource={dataNote}
                    renderItem={(item, index) => (
                      <List.Item>
                        <List.Item.Meta
                          title={
                            <Space>
                              <Typography.Text strong>
                                {item.USERNAME}:
                              </Typography.Text>
                              <Typography.Text
                                type="secondary"
                                style={{ fontSize: 12 }}
                              >
                                {dayjs(item.CreatedAt).format(
                                  "DD/MM/YYYY HH:mm",
                                )}
                              </Typography.Text>
                            </Space>
                          }
                          description={item.note}
                        />
                      </List.Item>
                    )}
                  />
                )}
              </>
            )}
            <Space split="|">
              <span>
                อัพเดทล่าสุด: {convertDateThai(workLawsuitDoc.UpdatedAt)}
              </span>
            </Space>
          </div>
        </div>
      </>
    );
  }, [workLawsuitDoc, convertDateThai, dataAsset, dataNote, showNote]);

  const renderFormDataSet = useMemo(() => {
    if (!dataLeasingCase) return null;

    return (
      <>
        <Divider>รายละเอียดของสัญญา {dataLeasingCase.contno}</Divider>
        <div
          style={{
            maxWidth: "1200px",
            margin: "0 auto",
            padding: "0 20px",
          }}
        >
          <Row gutter={[16, 0]}>
            <InfoItem
              label="วันที่ทำสัญญา"
              value={convertDateThai(dataLeasingCase.sdate)}
            />
            <InfoItem
              label="ยอดกู้"
              value={`${currencyFormatComma(dataLeasingCase.ncarcst || 0)} บาท`}
            />
            <InfoItem
              label="ดอกเบี้ยเช่าซื้อ"
              value={`${currencyFormatComma(
                dataLeasingCase.netprofit || 0,
              )} บาท`}
            />
            <InfoItem
              label="ภาษีเช่าซื้อ"
              value={`${currencyFormatComma(dataLeasingCase.vatprc || 0)} บาท`}
            />
            <InfoItem
              label="ยอดเช่าซื้อทั้งหมด"
              value={`${currencyFormatComma(dataLeasingCase.balanc || 0)} บาท`}
            />
            <InfoItem
              label="งวดทั้งหมด"
              value={`${dataLeasingCase.t_nopay || 0} งวด`}
            />
            <InfoItem
              label="ค่างวด"
              value={`${currencyFormatComma(
                dataLeasingCase.tot_upay || 0,
              )} บาท`}
            />
            <InfoItem
              label="ชำระมาแล้ว"
              value={`${currencyFormatComma(dataLeasingCase.netpay || 0)} บาท`}
            />
            <InfoItem
              label="เงินที่จ่ายไม่เต็มงวด"
              value={`${currencyFormatComma(dataLeasingCase.payment || 0)} บาท`}
            />
            <InfoItem
              label="ค่าส่งจดหมาย"
              value={`${currencyFormatComma(
                dataLeasingCase.collectionFee || 0,
              )} บาท`}
            />
            <InfoItem
              label="รับฝาก"
              value={`${currencyFormatComma(
                dataLeasingCase.total_hd_payment_amount || 0,
              )} บาท`}
            />
            <InfoItem
              label="ค้างงวด"
              value={`${dataLeasingCase.hldno || 0} งวด`}
            />

            <Col span={24}>
              <div
                style={{
                  display: "flex",
                  padding: "12px 16px",
                  background: "#fff2f0",
                  border: "1px solid #ffccc7",
                  borderRadius: "4px",
                  marginTop: "8px",
                  alignItems: "center",
                }}
              >
                <span
                  style={{
                    fontWeight: "bold",
                    fontSize: "16px",
                    minWidth: "140px",
                  }}
                >
                  ยอดคงเหลือ:
                </span>
                <span
                  style={{
                    flex: 1,
                    color: "#ff4d4f",
                    fontWeight: "bold",
                    fontSize: "18px",
                    paddingLeft: "12px",
                  }}
                >
                  {currencyFormatPoint(
                    dataLeasingCase.balanc - dataLeasingCase.netpay || 0,
                  )}{" "}
                  บาท
                </span>
              </div>
            </Col>
          </Row>
        </div>
      </>
    );
  }, [
    dataLeasingCase,
    convertDateThai,
    currencyFormatComma,
    currencyFormatPoint,
  ]);

  const renderFormDataSetLoand = useMemo(() => {
    if (!dataLeasingCase) return null;

    return (
      <>
        <Divider>รายละเอียดของสัญญา {dataLeasingCase.contno}</Divider>
        <div
          style={{
            maxWidth: "1200px",
            margin: "0 auto",
            padding: "0 20px",
          }}
        >
          <Row gutter={[16, 0]}>
            <InfoItem
              label="วันที่ทำสัญญา"
              value={convertDateThai(dataLeasingCase?.loan?.sdate)}
            />
            <InfoItem
              label="ยอดกู้"
              value={`${currencyFormatComma(
                dataLeasingCase?.loan?.ncshprc || 0,
              )} บาท`}
            />

            <InfoItem
              label="งวดทั้งหมด"
              value={`${dataLeasingCase?.loan?.tnopay || 0} งวด`}
            />
            <InfoItem
              label="ค่างวด"
              value={`${currencyFormatComma(
                dataLeasingCase?.loan?.totUpay || 0,
              )} บาท`}
            />

            <InfoItem
              label="ดอก"
              value={`${currencyFormatComma(
                dataLeasingCase?.loan?.dok || 0,
              )} บาท`}
            />
            <InfoItem
              label="ค้างดอก"
              value={`${currencyFormatPoint(
                dataLeasingCase?.loan?.kangdok || 0,
              )} บาท`}
            />
            <Col span={24}>
              <div
                style={{
                  display: "flex",
                  padding: "12px 16px",
                  background: "#fff2f0",
                  border: "1px solid #ffccc7",
                  borderRadius: "4px",
                  marginTop: "8px",
                  alignItems: "center",
                }}
              >
                <span
                  style={{
                    fontWeight: "bold",
                    fontSize: "16px",
                    minWidth: "140px",
                  }}
                >
                  ยอดคงเหลือ:
                </span>
                <span
                  style={{
                    flex: 1,
                    color: "#ff4d4f",
                    fontWeight: "bold",
                    fontSize: "18px",
                    paddingLeft: "12px",
                  }}
                >
                  {currencyFormatPoint(dataLeasingCase?.loan?.tonkong)} บาท
                </span>
              </div>
            </Col>
          </Row>
        </div>
      </>
    );
  }, [
    dataLeasingCase,
    convertDateThai,
    currencyFormatComma,
    currencyFormatPoint,
  ]);

  const renderOldJudge = useMemo(() => {
    const judge = oldJudgeDetail?.judge;
    if (!judge) return null;
    const lawsult = oldJudgeDetail?.lawsult;
    const loanNew = judge.loanNew;
    const money = (v) => `${currencyFormatPoint(v || 0)} บาท`;
    const rate = (v) => `${v || 0} % ต่อปี`;
    const judgeDef = judge.judgeDef?.[0];

    return (
      <>
        <Divider>ข้อมูลคำพิพากษาเดิม {judge.newContno}</Divider>
        <div
          style={{
            maxWidth: "1200px",
            margin: "0 auto",
            padding: "0 20px",
          }}
        >
          <Row gutter={[16, 0]}>
            <InfoItem label="ศาล" value={lawsult?.provincialCourt || "-"} />
            <InfoItem
              label="คดีหมายเลขดำ"
              value={lawsult?.blackCaseNumber || "-"}
            />
            <InfoItem
              label="คดีหมายเลขแดง"
              value={judge.redCaseNumber || "-"}
            />

            <InfoItem label="ยอดตามคำพิพากษา" value={money(judge.judgement)} />
            <InfoItem
              label="ดอกเบี้ยเงินต้น"
              value={rate(
                Number(judge.judgeInterestRate) > 0
                  ? judge.judgeInterestRate
                  : judge.interestRate,
              )}
            />

            <InfoItem
              label="ค่าขาดประโยชน์"
              value={money(judge.lackOfBenefits)}
            />

            <InfoItem label="ลูกหนี้อื่น ๆ" value={money(judge.AROTHR)} />
            <InfoItem label="ยอดหนี้ทั้งหมด" value={money(judge.totalJugde)} />
            {loanNew && (
              <>
                <InfoItem
                  label="ยอดผ่อนตามยอม"
                  value={money(loanNew.NCSHPRC)}
                />
                <InfoItem
                  label="งวดทั้งหมด"
                  value={`${loanNew.T_NOPAY || 0} งวด`}
                />
                <InfoItem label="ค่างวด" value={money(loanNew.TOT_UPAY)} />
                <InfoItem
                  label="งวดแรก"
                  value={convertDateThai(loanNew.FDATE)}
                />
                <InfoItem
                  label="งวดสุดท้าย"
                  value={convertDateThai(loanNew.LDATE)}
                />
                <InfoItem
                  label="ยอดคงเหลือ"
                  value={money(loanNew.LOAN_NEW_TONBALANCE)}
                />
              </>
            )}
          </Row>
        </div>
      </>
    );
  }, [oldJudgeDetail, convertDateThai, currencyFormatPoint, InfoItem]);

  const renderDataForLawsuit = useMemo(() => {
    return (
      <Form
        form={form}
        layout="vertical"
        onFinish={onFinish}
        onFinishFailed={onFinishFailed}
        style={{ marginTop: "24px" }}
      >
        <Divider orientation="center">ข้อมูลการฟ้อง</Divider>

        <Row gutter={[16, 8]}>
          <Col xs={24} md={8}>
            <Form.Item
              label="วันที่ส่งฟ้อง"
              name="dateCourt"
              rules={[
                {
                  required: true,
                  message: "กรุณาเลือกวันที่ส่งฟ้อง",
                },
              ]}
            >
              <ThaiDatePicker
                size="large"
                placeholder="เลือกวันที่"
                style={{ width: "100%" }}
                onChange={(value) => {
                  if (!lawsuitOldData) {
                    handleLoadDataLeasing(value);
                  }
                }}
                disabledDate={(current) => {
                  // ถ้า current มีค่า และ วันที่ "ไม่ใช่ 12" และ "ไม่ใช่ 26" -> ให้ disable (true)
                  return current && current < dayjs().startOf("day");
                }}
              />
            </Form.Item>
          </Col>

          <Col xs={24} md={8}>
            <Form.Item
              label="บริษัทที่ส่งคำฟ้อง"
              name="company"
              rules={[
                {
                  required: true,
                  message: "โปรดเลือกบริษัท",
                },
              ]}
            >
              <Select
                size="large"
                placeholder="เลือกบริษัท"
                showSearch
                optionFilterProp="label"
                style={{ width: "100%" }}
                options={optionsCompany}
              />
            </Form.Item>
          </Col>
          <Col xs={24} md={8}>
            <Form.Item
              label="ศาล"
              getValueFromEvent={(option) => option?.label} // ✅ เก็บแค่ label
              name="court"
              rules={[
                {
                  required: true,
                  message: "กรุณาพิมพ์ศาลที่ยื่นฟ้อง !",
                },
              ]}
            >
              <Select
                popupMatchSelectWidth={false}
                size="large"
                style={{
                  width: "auto",
                }}
                placeholder="เลือกศาล"
                showSearch
                optionFilterProp="label"
                options={allCourtOptions}
                labelInValue // ✅ เพิ่ม prop นี้
                // onChange={(option) => {
                //   // option จะมีทั้ง value และ label
                //   console.log(option); // { value: "xxx", label: "ชื่อศาล" }
                //   onChangeInputCourt(option.label); // ส่ง label
                // }}
              />
            </Form.Item>
          </Col>
        </Row>

        <Row gutter={[16, 8]}>
          <Col xs={24} md={12}>
            <Form.Item
              label="ความ"
              name="lawType"
              rules={[
                {
                  required: true,
                  message: "กรุณาเลือกประเภทการฟ้อง",
                },
              ]}
            >
              <Select
                size="large"
                placeholder="โปรดเลือกประเภทการฟ้อง"
                showSearch
                optionFilterProp="label"
                options={optionsLone}
                onChange={onChangeSelectLoanType}
                allowClear
              />
            </Form.Item>
          </Col>

          <Col xs={24} md={12}>
            <Form.Item
              label="เรื่อง"
              name="subject"
              rules={[
                {
                  required: true,
                  message: "กรุณาระบุเรื่องที่ยื่นฟ้อง",
                },
              ]}
            >
              <Input size="large" placeholder="ระบุเรื่องที่ยื่นฟ้อง" />
            </Form.Item>
          </Col>
        </Row>

        <Row gutter={[16, 8]}>
          <Col span={24}>
            <Form.Item
              copyable={true}
              label={`ทุนทรัพย์ที่จะใช้ฟ้อง (ไม่รวมรับฝาก ${currencyFormatComma(
                dataLeasingCase?.total_hd_payment_amount ||
                  dataLeasingCase?.loan?.hdpayment ||
                  0,
              )} บาท)`}
              name="litigation"
            >
              <Radio.Group
                options={litigationOptions}
                onChange={onChangeInvestiGateResult}
                value={radioStatus}
                size="large"
                copyable={true}
              />
            </Form.Item>
          </Col>

          <Col xs={24} md={12}>
            <Form.Item
              label={
                <span>
                  จำนวนทุนทรัพย์เฮียกำหนด{" "}
                  <Typography.Text type="secondary" style={{ fontSize: 12 }}>
                    (ก่อนฟ้อง)
                  </Typography.Text>
                </span>
              }
              name="preLitigationFounds"
              rules={[
                {
                  required: true,
                  message: "กรุณาใส่จำนวนทุนทรัพย์เฮียกำหนด",
                },
              ]}
            >
              <InputNumber
                disabled
                size="large"
                precision={2}
                suffix="บาท"
                formatter={(value) =>
                  `${value}`.replace(/\B(?=(\d{3})+(?!\d))/g, ",")
                }
                parser={(value) => value.replace(/\$\s?|(,*)/g, "")}
                placeholder="จำนวนทุนทรัพย์เฮียกำหนด"
                style={{ width: "100%" }}
              />
            </Form.Item>
          </Col>

          <Col xs={24} md={12}>
            <Form.Item
              label={
                <span>
                  จำนวนทุนทรัพย์{" "}
                  <Typography.Text type="secondary" style={{ fontSize: 12 }}>
                    (ตอนฟ้อง)
                  </Typography.Text>
                </span>
              }
              name="litigationFounds"
              rules={[{ required: true, message: "กรุณาใส่จำนวนทุนทรัพย์" }]}
            >
              <InputNumber
                disabled={
                  dataLoadLawsuit?.workExpenseList?.length > 0 &&
                  dataLoadLawsuit.workExpenseList.every((item) => item.TMBILL)
                }
                size="large"
                precision={2}
                suffix="บาท"
                formatter={(value) =>
                  `${value}`.replace(/\B(?=(\d{3})+(?!\d))/g, ",")
                }
                parser={(value) => value.replace(/\$\s?|(,*)/g, "")}
                placeholder="จำนวนทุนทรัพย์"
                style={{ width: "100%" }}
                onChange={onChangelitigationFounds}
              />
            </Form.Item>
          </Col>

          <Col xs={24} md={12}>
            <Form.Item
              label={
                <span>
                  ค่าขาดประโยชน์เฮียกำหนด{" "}
                  <Typography.Text type="secondary" style={{ fontSize: 12 }}>
                    (ก่อนฟ้อง)
                  </Typography.Text>
                </span>
              }
              name="preLostProfitAmount"
              rules={[
                {
                  required: true,
                  message: "กรุณาใส่ค่าขาดประโยชน์เฮียกำหนด",
                },
              ]}
            >
              <InputNumber
                disabled
                size="large"
                precision={2}
                suffix="บาท"
                formatter={(value) =>
                  `${value}`.replace(/\B(?=(\d{3})+(?!\d))/g, ",")
                }
                parser={(value) => value.replace(/\$\s?|(,*)/g, "")}
                placeholder="ค่าขาดประโยชน์เฮียกำหนด"
                style={{ width: "100%" }}
              />
            </Form.Item>
          </Col>

          <Col xs={24} md={12}>
            <Form.Item
              label={
                <span>
                  ค่าขาดประโยชน์{" "}
                  <Typography.Text type="secondary" style={{ fontSize: 12 }}>
                    (ตอนฟ้อง)
                  </Typography.Text>
                </span>
              }
              name="lostProfitAmount"
              rules={[{ required: true, message: "กรุณาใส่ค่าขาดประโยชน์" }]}
            >
              <InputNumber
                size="large"
                precision={2}
                suffix="บาท"
                formatter={(value) =>
                  `${value}`.replace(/\B(?=(\d{3})+(?!\d))/g, ",")
                }
                parser={(value) => value.replace(/\$\s?|(,*)/g, "")}
                placeholder="ค่าขาดประโยชน์"
                style={{ width: "100%" }}
                onChange={onChangelostProfitAmount}
              />
            </Form.Item>
          </Col>
          <Col xs={24} md={12}>
            <Form.Item
              label="ค่าติดตามทวงถาม"
              name="trackingFee"
              // rules={[
              //   {
              //     required: true,
              //     message: "กรุณาใส่ค่าติดตาม",
              //   },
              // ]}
            >
              <InputNumber
                size="large"
                precision={2}
                suffix="บาท"
                formatter={(value) =>
                  `${value}`.replace(/\B(?=(\d{3})+(?!\d))/g, ",")
                }
                parser={(value) => value.replace(/\$\s?|(,*)/g, "")}
                placeholder="กรุณาใส่ค่าติดตาม"
                style={{ width: "100%" }}
              />
            </Form.Item>
          </Col>
          <Col xs={24} md={12}>
            <Form.Item
              label="ค่าธรรมเนียมศาล"
              name="courtFee"
              rules={[
                {
                  required: true,
                  message: "กรุณาใส่ค่าธรรมเนียมศาล",
                },
              ]}
            >
              <InputNumber
                disabled={
                  dataLoadLawsuit?.workExpenseList?.length > 0 &&
                  dataLoadLawsuit.workExpenseList.every((item) => item.TMBILL)
                }
                size="large"
                precision={2}
                suffix="บาท"
                formatter={(value) =>
                  `${value}`.replace(/\B(?=(\d{3})+(?!\d))/g, ",")
                }
                parser={(value) => value.replace(/\$\s?|(,*)/g, "")}
                placeholder="ค่าธรรมเนียมศาล"
                style={{ width: "100%" }}
              />
            </Form.Item>
          </Col>

          <Col xs={24} md={12}>
            <Form.Item
              label="ค่าส่งหมาย"
              name="deliveryDoc"
              rules={[
                {
                  required: true,
                  message: "กรุณาใส่ค่าส่งหมาย",
                },
              ]}
            >
              <InputNumber
                disabled={
                  dataLoadLawsuit?.workExpenseList?.length > 0 &&
                  dataLoadLawsuit.workExpenseList.every((item) => item.TMBILL)
                }
                size="large"
                precision={2}
                suffix="บาท"
                formatter={(value) =>
                  `${value}`.replace(/\B(?=(\d{3})+(?!\d))/g, ",")
                }
                parser={(value) => value.replace(/\$\s?|(,*)/g, "")}
                placeholder="กรุณาใส่ค่าส่งหมาย"
                style={{ width: "100%" }}
              />
            </Form.Item>
          </Col>
          <Col xs={24} md={12}>
            <Form.Item
              label="ค่าจัดทำเอกสาร"
              name="docCost"
              rules={[
                {
                  required: true,
                  message: "กรุณาใส่ค่าจัดทำเอกสาร",
                },
              ]}
            >
              <InputNumber
                size="large"
                precision={2}
                suffix="บาท"
                formatter={(value) =>
                  `${value}`.replace(/\B(?=(\d{3})+(?!\d))/g, ",")
                }
                parser={(value) => value.replace(/\$\s?|(,*)/g, "")}
                placeholder="กรุณาใส่ค่าจัดทำเอกสาร"
                style={{ width: "100%" }}
                disabled
              />
            </Form.Item>
          </Col>
        </Row>

        <Form.Item label="หมายเหตุ" name="memo">
          <TextArea
            rows={4}
            placeholder="กรอกหมายเหตุ (ถ้ามี)"
            showCount
            maxLength={500}
          />
        </Form.Item>

        {/* ปุ่มดำเนินการ */}
        <div style={{ textAlign: "center", marginTop: "24px" }}>
          <Space size="middle">
            <Button
              onClick={handleCancel}
              danger
              size="large"
              style={{ minWidth: 120 }}
            >
              ยกเลิก
            </Button>

            <Button
              type="primary"
              htmlType="submit"
              size="large"
              style={{ minWidth: 120 }}
            >
              {isEditMode ? "บันทึกการแก้ไข" : "บันทึก"}
            </Button>
          </Space>
        </div>
      </Form>
    );
  }, [
    form,
    onFinish,
    onFinishFailed,
    onChangeSelectLoanType,
    litigationOptions,
    onChangeInvestiGateResult,
    radioStatus,
    onChangelitigationFounds,
    handleCancel,
    isEditMode,
    handleLoadDataLeasing,
  ]);
  // ========================================
  // Main Render
  // ========================================

  return (
    <Modal
      title={`${isEditMode ? "แก้ไข" : "ส่ง"}ทนายฟ้องสัญญา - ${
        dataDefault?.CONTNO || ""
      }`}
      open={open}
      onCancel={handleCancel}
      width={1200}
      footer={null}
      destroyOnHidden
    >
      <Spin spinning={loading} size="large" tip="กำลังโหลดข้อมูล...">
        {renderDocumentChecklist}
        {console.log(dataDefault.SCHEMA)}

        {dataDefault.SCHEMA === "lsfhp" || dataDefault.SCHEMA === "rpsl"
          ? renderFormDataSetLoand
          : renderFormDataSet}
        {renderOldJudge}
        {renderDataForLawsuit}
      </Spin>
      {isModalDebtPayment && (
        <DebtPayment
          open={isModalDebtPayment}
          close={() => setIsModalDebtPayment(false)}
          initialContractNo={dataDefault.CONTNO}
          initialDataType={null}
          dataDefault={dataDefault}
        />
      )}
      {isModalNotify && (
        <DetailNotify
          open={isModalNotify}
          close={() => setIsModalNotify(false)}
          initialContractNo={dataDefault.CONTNO}
          initialDataType={null}
          dataDefault={dataDefault}
        />
      )}

      {isModalWcc && (
        <DetailWcc
          open={isModalWcc}
          close={() => setIsModalWcc(false)}
          initialContractNo={dataDefault.CONTNO}
          initialDataType={null}
          dataDefault={dataDefault}
        />
      )}
      {isModalDetailAsset && (
        <DetailAsset
          open={isModalDetailAsset}
          close={() => setIsModalDetailAsset(false)}
          initialContractNo={dataDefault.CONTNO}
          initialDataType={null}
          dataDefault={dataDefault}
        />
      )}
      {isModalDetailTr && (
        <AddressTrDetail
          open={isModalDetailTr}
          close={() => setIsModalDetailTr(false)}
          initialContractNo={dataDefault.CONTNO}
          initialDataType={null}
          dataDefault={dataDefault}
        />
      )}
    </Modal>
  );
};

export default SendToLawsuit;
